module.exports = __webpack_public_path__ + "images/bannerDE-0558696e8780bbaf958322fd467dcd07.jpg";